<template>
  <div class="w-100">Job manually set to Unreachable</div>
</template>

<script type="text/babel">
import BaseComponent from "./BaseComponent.vue";

export default {
  extends: BaseComponent,
};
</script>
